import axios from 'axios'

import {
    CREATE_CART,
    UPDATE_CART,
    GET_FEE,
    GET_ADDRESS_BY_POSTAL_CODE,
    AGENT_DATE,
    RECOVERY_CART,
    CREATE_PRODUCT,
    GET_CART,
    CHECK_CNPJ
} from '../utils/UrlConstants'

import StringFormat from '../utils/StringFormat'
import { aleloPodGroups } from 'constants/pod-groups'
import { aleloTudoGroups } from 'constants/alelo-tudo-groups'

export const getShoppingCart = (id) => {
    return axios.get(GET_CART.replace(':cartId', id))
}

export const createShoppingCart = (payload) => {
    return axios.post(CREATE_CART, payload)
}

const formatGroups = (groups, isPat) => {
    if (!groups) {
        return undefined
    }

    return groups.items
        .filter(
            (group) =>
                group.qnt !== '' &&
                group.qnt !== 0 &&
                group.value !== '' &&
                group.value !== 0 &&
                getGroupByType(group.type).isPat.includes(isPat)
        )
        .flatMap((group) => {
            const code = getGroupByType(group.type).code
            if (Array.isArray(code) && code.length > 0) {
                return code.map((c) => ({
                    code: c,
                    paymentValue: parseFloat(group.value),
                    amount: parseFloat(group.qnt)
                }))
            }

            return [
                {
                    code: code,
                    paymentValue: parseFloat(group.value),
                    amount: parseFloat(group.qnt)
                }
            ]
        })
}

const getGroupByType = (type) => {
    if (!type) {
        return null
    }

    let group = aleloTudoGroups.find((item) => item.type === type)

    if (!group) {
        group = aleloPodGroups.find((item) => item.type === type)
    }

    return group
}

export const updateShoppingCart = (id, payload) => {
    const spokesmanPhone = payload.spokesman.phone.replace(/\D/g, '')

    const products = payload.products.map((product) => ({
        code: product.id,
        name: StringFormat.nameProducts(product.id),
        paymentValue: parseFloat(product.value),
        amount: product.qnt,
        isPat: product.isPat,
        groups: formatGroups(product.groups, product.isPat)
    }))

    const data = {
        status: payload.status,
        paymentType: payload.paymentType,
        company: {
            document: payload.company.document,
            fantasyName: payload.company.fantasyName,
            businessName: payload.company.businessName
                ? payload.company.businessName
                : payload.company.name,
            nameAtCard: payload.company.tradeName,
            deliveryAddress: {
                ...payload.company.deliveryAddress,
                postalCode: payload.company.deliveryAddress.postalCode.replace(
                    '-',
                    ''
                ),
                number: payload.company.deliveryAddress.number
                    ? payload.company.deliveryAddress.number
                    : null
            },
            billingAddress: {
                ...payload.company.billingAddress,
                postalCode: payload.company.billingAddress.postalCode.replace(
                    '-',
                    ''
                ),
                number: payload.company.billingAddress.number
                    ? payload.company.billingAddress.number
                    : null
            },
            dateOfEstablishment: payload.company.dateOfEstablishment,
            numberOfEmployees: parseInt(payload.company.numberOfEmployees, 10),
            companyType: payload.company.companyType,
            companySize: payload.company.companySize,
            cityInscription: parseInt(payload.company.cityInscription),
            stateInscription: parseInt(payload.company.stateInscription),
            cnaeSectionCode: payload.company.cnaeSectionCode,
            cnaeDivisionType: payload.company.cnaeDivisionType,
            patNumber: payload.company.patNumber
        },
        vendor: payload.bank.agency
            ? { ...payload.bank, name: payload.bank.name.toUpperCase() }
            : null,
        spokesman: {
            documentNumber: payload.spokesman.documentNumber,
            name: payload.spokesman.name,
            prefixNumber: spokesmanPhone.slice(0, 2),
            phone: spokesmanPhone.slice(2),
            email: payload.spokesman.email,
            birthday: payload.spokesman.birthDate
        },
        products,
        proposalEmail: payload.proposalEmail
    }

    if (payload.management) {
        const managementPhone = payload.management.phone.replace(/\D/g, '')

        data.management = {
            documentNumber: payload.management.documentNumber,
            name: payload.management.name,
            prefixNumber: managementPhone.slice(0, 2),
            phone: managementPhone.slice(2),
            email: payload.management.email,
            birthday: payload.management.birthDate
        }
    }

    return axios.patch(`${UPDATE_CART}/${id}`, data)
}

export const pollingDocumentCheck = (cartId) =>
    axios.get(`${CHECK_CNPJ}/${cartId}`).then((res) => {
        if (!res.data.validationIsEnded) {
            throw new Error('Validation not ended')
        }
        return res.data
    })

export const getFee = (cartId, bank) => {
    return axios.get(
        GET_FEE.replace(':cartId', cartId).replace(':origin', bank)
    )
}

export const getAddress = (postalCode) => {
    return axios.get(GET_ADDRESS_BY_POSTAL_CODE, {
        params: {
            zipCode: postalCode
        },
        timeout: 15000
    })
}

export const agentDate = () => axios.get(AGENT_DATE)

export const recovery = (cartId, payload) => {
    return axios.post(RECOVERY_CART.replace(':cartId', cartId), payload)
}

export const createProduct = (cartId, payload) => {
    return axios.post(CREATE_PRODUCT.replace(':cartId', cartId), payload)
}
